export default {
  data: {
    courses: [],
    categories: [],
    levels: [],
    filteredSubjects: [],
    filteredLevels: [],
    filteredSubjectsNames: [],
    paginator: null,
    show_share_modal: false,
    share_modal_params: null,
    filterApplied: true,
    searchQuery: '',
    mobileBreakPoint: 768,

  },

  watch: {
    filteredLevels() { this.filterChanged(); },
    filteredSubjects() { this.filterChanged(); },
    searchQuery() { this.filterChanged(); },
  },

  methods: {
    initializeData(data, type){
      self = this
      if(type=='micro'){
        this.courses = data.micro_courses;
      } else {
        this.courses = data.standard_courses;
      }
      this.default_course = data.default_course;
      this.paginator = data.paginator;
      this.type = type;
      self.categories = data.categories;
      self.filteredCategories = data.filteredCategories || [];
      self.levels = data.levels;
    },

    updateUrlParams(url) {
      var historyApi = typeof history.replaceState !== 'undefined';
      if (historyApi) {
        var state = _.extend({}, history.state, {url: url});
        history.replaceState(state, 'Course', url);
      }
    },

    removeSubject(id) {
      this.filteredSubjects.splice(this.filteredSubjects.indexOf(id.toString()), 1);
    },

    removeLevel(level) {
      this.filteredLevels.splice(this.filteredLevels.indexOf(level), 1);
    },

    clearFilters() {
      this.filteredSubjects = [];
      this.filteredLevels = [];
      this.filterChanged();
    },

    filterChanged() {
      this.courseListing();
    },

    buildQuery() {
      var query = {};

      if (!_.isEmpty(this.searchQuery)) {
        query['q'] = this.searchQuery;
      }
      self.filterApplied = false;

      query['subjects'] = this.filteredSubjects || [];
      query['levels'] = this.filteredLevels || [];

      console.log('query: ' + $.param(query));
      return $.param(query);
    },

    courseListing(url_param, _currentPage) {
      var path = Kadenze.Routes.standard_courses_path();; 
      if(self.type == 'micro') {
        path = Kadenze.Routes.micro_courses_path();
      }
      
      var url = path;
      var params = this.buildQuery();

      if(params) {
        url = url + '?' + params;
      } else if(url_param) {
        url = url_param;
      }
      
      const request = new Kadenze.AjaxRequest({
        type: 'GET',
        url: url,
        loadingIndicator: true,
        beforeSend: function() {
          self.updateUrlParams(this.url);
        }
      });

      request.done((data) => {

        var courses = null;
        if(self.type == 'micro') {
          courses = JSON.parse(data.micro_courses);        
        } else {
          courses = JSON.parse(data.standard_courses);
        }

        if(courses.query_params) {
          if(courses.query_params.subjects){
            courses.filteredCategories = self.getFilteredObjects(self.categories, courses.query_params.subjects);
            self.filterApplied = true;
          }
          if(Kadenze.isKadenze && courses.query_params.levels) {
            self.filterApplied = true;
          }
        }
        $('.select-box').removeClass('hide');
        self.searchEnabled = false;
        
        self.initializeData(courses, self.type);
      });

      request.fail((data) => {
        console.warn('error retrieving session data');
        console.log(data);

        new Kadenze.Notice.error({
          message: 'There was a problem loading Courses, please contact system administrators'
        });
      });
    },

    showShareModal(params) {
      this.share_modal_params = params;
      this.show_share_modal = true;
    },

    initializeBindData(data,type) {
      this.initializeData(data, type);
    },

    getObjectById(array, id) {
      const value = _.find(array, function(obj) {
        return obj.id == id
      });

      return value;
    },

    getFilteredObjects(array, ids = []) {
      var names = [];
      ids.forEach(id=>{
        const name = self.getObjectById(array, id);
        names.push(name);
      });

      return names;
    },

    appliedfilterDataNotPresent() {
      return (self.courses.length === 0) 
    },

    filtersCount() {
      return (self.filteredCategories.length + (self.filteredLevels || []).length )
    },

    enableSearch() {
      $('.select-box').addClass('hide');
    },

    mobileView() {
      var windowWidth = screen.width;
      return (windowWidth < self.mobileBreakPoint);
    },

  },

  mounted() {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(this.courseListing);
  }
};
